module.exports = __webpack_public_path__ + "9fa02a0267ba7cdbec9df30c1181d9b6.png";